<div class="modal-header">
  <h3 class="modal-title">Report QA Confirmation</h3>
  <button type="button" class="close" (click)="close()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="center">
    <span
      class="icon k-icon k-font-icon k-i-check-outline k-i-checkmark-outline k-i-success"></span>
    <span>
      <b>QA report successfully created</b>
    </span>
  </div>

  &nbsp; &nbsp;

  <div class="row info">
    <div class="col-sm-4">Client number:</div>
    <div class="col-sm-6">{{ inputData.clientInfo?.no }}</div>
  </div>
  <div class="row">
    <div class="col-sm-4">Client name:</div>
    <div class="col-sm-7">{{ inputData.clientInfo?.name }}</div>
  </div>
  <div class="row">
    <div class="col-sm-4">Task name:</div>
    <div class="col-sm-7">
      {{ inputData.qaTask?.name }} ({{ inputData.qaTask?.processName }} ->
      {{ inputData.qaTask?.activityName }})
    </div>
  </div>
</div>
